import { render } from "./MeasureTypeDetail.vue?vue&type=template&id=fbfb769c&scoped=true"
import script from "./MeasureTypeDetail.vue?vue&type=script&lang=js"
export * from "./MeasureTypeDetail.vue?vue&type=script&lang=js"

import "./MeasureTypeDetail.vue?vue&type=style&index=0&id=fbfb769c&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfb769c"]])

export default __exports__